import Header from 'components/headers/wallet'
import useGetInitPaymentOs from './hooks/useGetInitPaymentOs'
import WalletBalance from './balance'
import CustomBottomSheet from 'components/bottomSheet'
import { useEffect, useState } from 'react'
import Increase from './increase'
import posthog from 'posthog-js'

export default function WalletPage() {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { data, isLoading } = useGetInitPaymentOs(profile?.id)

    useEffect(() => {
        if (data) {
            posthog.capture('wallet_viewed', {
                wallet_balance: (data as any)?.wallet_balance,
            })
        }
    }, [data])

    return (
        <>
            <div className=" h-screen flex flex-col ">
                <div className=" flex-none">
                    <Header title="کیف پول" />
                </div>
                <WalletBalance
                    wallet_balance={data?.wallet_balance}
                    isLoading={isLoading}
                />
                <div className=" grow flex justify-end flex-col">
                    <button
                        className=" bg-green-1 text-white my-4 mx-4 py-3 rounded-2xl "
                        onClick={() => {
                            posthog.capture('wallet_topup_opened')
                            setIsOpen(true)
                        }}
                    >
                        افزایش موجودی
                    </button>
                </div>
            </div>
            <CustomBottomSheet
                onDismiss={() => setIsOpen(false)}
                isOpen={isOpen}
            >
                <Increase setIsOpen={setIsOpen} />
            </CustomBottomSheet>
        </>
    )
}
